import React, { useRef } from 'react';
import GxForm from '../../gx/GxForm';
import { useTranslation } from '../../hx/useTranslation';
import { useNav } from '../../hx/useNav';
import CxHidden from '../../cx/CxHidden';
import CxInput from '../../cx/CxInput';
// eslint-disable-next-line no-unused-vars
import * as FxLog from '../../fx/FxLog';
import { StoreSettCash } from "../../gx/GxStore";
import { useSessionStorage } from '../../hx/useSessionStorage';


const MxSettCashForm = (props) => {
  const [{ trans }] = useTranslation();
  const [{ navBack }] = useNav();

  let r_form = React.useRef(null);

  const [storeSettCash, setStoreSettCash] = useSessionStorage('StoreSettCash', StoreSettCash);

  const formLoad = async (data) => {
    if (data===null) { //nuevo registro
    }
  }
  const formSave = async (lastSaveRv) => {
    if (lastSaveRv.theStatus==='error') {
    } else {
      storeSettCash.itCash = lastSaveRv.theValue;
      Promise.all([setStoreSettCash(storeSettCash)]).then((result) => {
        navBack();
      });
    }
  }
  const formDelete = async (rv) => {
  }

  return (
    <div>
      <GxForm 
        moduleName={`${trans('field.type')} - ${trans('field.cash_reg')}`}
        xref={r_form}
        url="sett/cash" 
        filterIdField='itCash'
        filterIdValue={storeSettCash.itCash} 
        onFormLoad={formLoad} 
        onFormSave={formSave} 
        saveAndExit
        onFormDelete={formDelete} 
        >
        <CxHidden xref={useRef(null)} dbfield="t_cash.itCash" value={storeSettCash.itCash || ''} />
        <CxInput xref={useRef(null)} label={trans('field.cash_reg')} dbfield="t_cash.txTypeCash" required />
        
      </GxForm>

    </div>
  );

}

export default MxSettCashForm;
